/**
 * Format a number in a compact way with suffix (K, M, B, T)
 */
export const formatCompactNumber = (num: number): string => {
  if (num === 0) return '0';
  
  const suffixes = ['', 'K', 'M', 'B', 'T', 'Q'];
  const tier = Math.floor(Math.log10(Math.abs(num)) / 3);
  
  if (tier === 0) return Math.round(num).toString();
  
  const suffix = suffixes[tier] || `e${tier * 3}`;
  const scale = Math.pow(10, tier * 3);
  const scaled = num / scale;
  
  // Different precision based on scaled value
  let precision = 1;
  if (scaled < 10) precision = 2;
  else if (scaled < 100) precision = 1;
  else precision = 0;
  
  return scaled.toFixed(precision) + suffix;
};
